import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Clock, Instagram, Facebook, Linkedin } from 'lucide-react';
import { companyInfo } from '../mock/mockData';

const socialLinks = [
  { name: 'Instagram', href: 'https://www.instagram.com/idk_bokt/', icon: Instagram },
  { name: 'Facebook', href: 'https://www.facebook.com/idk.bokt.mmc', icon: Facebook },
  { name: 'LinkedIn', href: 'https://www.linkedin.com/company/idk-bokt', icon: Linkedin }
];

export const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10 sm:py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company info */}
          <div className="col-span-1 md:col-span-2">
            <div className="mb-4">
              <img src="/logo-idk-white.png" alt="İDK" className="h-9 w-auto" data-testid="footer-logo" />
            </div>
            <p className="text-sm text-gray-400 mb-4 max-w-md">
              {companyInfo.fullName}
            </p>
            <div className="space-y-2 text-sm">
              {companyInfo.phones.map((phone, idx) => (
                <a key={phone} href={`tel:${phone.replace(/\s/g, '')}`} className="flex items-center space-x-2 hover:text-blue-400 transition-colors">
                  <Phone className="h-4 w-4 text-blue-400 flex-shrink-0" />
                  <span>{phone}</span>
                </a>
              ))}
              <a href={`mailto:${companyInfo.email}`} className="flex items-center space-x-2 hover:text-blue-400 transition-colors">
                <Mail className="h-4 w-4 text-blue-400 flex-shrink-0" />
                <span>{companyInfo.email}</span>
              </a>
              <div className="flex items-start space-x-2">
                <MapPin className="h-4 w-4 text-blue-400 flex-shrink-0 mt-0.5" />
                <span>{companyInfo.address}</span>
              </div>
              <div className="flex items-center space-x-2">
                <Clock className="h-4 w-4 text-blue-400 flex-shrink-0" />
                <span>{companyInfo.workingHours}</span>
              </div>
            </div>
            <div className="flex items-center gap-3 mt-6">
              {socialLinks.map((social) => {
                const Icon = social.icon;
                return (
                  <a
                    key={social.name}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={social.name}
                    className="flex h-9 w-9 items-center justify-center rounded-lg bg-gray-800 text-gray-400 hover:bg-blue-700 hover:text-white transition-colors"
                    data-testid={`social-${social.name.toLowerCase()}`}
                  >
                    <Icon className="h-4 w-4" />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Haqqımızda */}
          <div>
            <h3 className="text-white font-semibold mb-4">Haqqımızda</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/haqqimizda/biz-kimik" className="hover:text-blue-400 transition-colors">Biz kimik?</Link></li>
              <li><Link to="/haqqimizda/rehberlik" className="hover:text-blue-400 transition-colors">Rəhbərlik</Link></li>
              <li><Link to="/haqqimizda/hesabatlar" className="hover:text-blue-400 transition-colors">Hesabatlar</Link></li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-white font-semibold mb-4">Məhsullar</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/mehsullar/istehlak-kreditleri" className="hover:text-blue-400 transition-colors">İstehlak Krediti</Link></li>
              <li><Link to="/mehsullar/qizil-kreditleri" className="hover:text-blue-400 transition-colors">Qızıl Krediti</Link></li>
              <li><Link to="/mehsullar/avto-lizinq" className="hover:text-blue-400 transition-colors">Avto Lizinq</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} İDK BOKT. Bütün hüquqlar qorunur.
          </p>
          <div className="flex items-center gap-6 text-sm">
            <Link to="/faq" className="text-gray-400 hover:text-blue-400 transition-colors">
              Tez-tez verilən suallar
            </Link>
            <Link to="/mexfilik-siyaseti" className="text-gray-400 hover:text-blue-400 transition-colors">
              Məxfilik siyasəti
            </Link>
            <Link to="/istifade-shertleri" className="text-gray-400 hover:text-blue-400 transition-colors">
              İstifadə şərtləri
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
